import React, {useState, useEffect} from 'react';
import WhitePapersView from "./WhitePapersView";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getAllPublications} from "../KnowledgeBankAction";


function WhitePapers(props) {
    const [whitePaperPageState, setWhitePaperPageState] = useState({
        publications: [],
        isApiInProgress: false,
        apiErrorMessage: '',
    });

    useEffect(() => {
        setWhitePaperPageState(prevState => ({...prevState, isApiInProgress: true}));
        getAllPublications()
            .then(res => {
                if (res.success) {
                    setWhitePaperPageState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        publications: res.data,
                    }));
                } else {
                    setWhitePaperPageState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        apiErrorMessage: res.__error,
                    }));
                }
            });
    }, []);

    return (
        <WhitePapersView {...props} {...whitePaperPageState}/>
    );
}

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isMobileDevice: state.appState.deviceInfo.isMobileDevice,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isXSView: state.appState.deviceInfo.isXSView,
    searchWhitepaperText:state.appState.searchWhitepaperText
});

export default connect(mapStateToProps, {})(withRouter(WhitePapers));
